<script lang='ts'>

    /* IMPORTS ------------------------------------------------- */

    import {
        ANALYTICS,
        AUTHENTICATION,
        Loader,
        MONITORING,
        QUERY_STATE,
        SESSION_API,
        SESSION_ORGANIZATION,
        SESSION,
        STATE,
        TOKEN,
    } from '@smatch/cassiopeia-web-components';

    // CONFIG
    import { SENTRY_DSN } from './config';

    // UTILS
    import Router from './app/Router.svelte';
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';

    /* MONITORING ----------------------------------------------- */

    const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT as string;

    MONITORING.init(SENTRY_DSN, ENVIRONMENT);
    SESSION.subscribe(MONITORING.setUserContext);

    /* ANALYTICS ----------------------------------------------- */

    SESSION.subscribe(ANALYTICS.trackUserSession);

    /* ROUTING / CAMPAIGN HANDLING ------------------------------ */

    const CAMPAIGN_TOKEN_IN_URL = QUERY_STATE.getParameter('token', 'auction') as string | undefined;
    const MAGIC_TOKEN_IN_URL = QUERY_STATE.getParameter('token') as string | undefined;

    const fetchSession = async (token: string | null | undefined): Promise<void> => {

        if (token === undefined) {
            return;
        }

        if (token === null) {
            return;
        }

        await SESSION_API.fetchSession(token);
    };

    const checkCachedToken = async (): Promise<void> => {
        await fetchSession($TOKEN);
    };

    const checkCampaignToken = async (): Promise<void> => {
        await fetchSession(CAMPAIGN_TOKEN_IN_URL);

        if ($TOKEN === undefined) {
            return;
        }
        STATE.update(state => ({ ...state, campaignToken: get(TOKEN) ?? null }));
        QUERY_STATE.removeParameter('token', 'auction');
    };

    const checkTokens = async (): Promise<void> => {

        /*
         * If the user is currently authenticated with a campaign token, and is returning
         *  with another campaign token in the URL, delete the cached tokens, as they will
         *  not allow the user to access the new auction
         */
        if ($STATE.campaignToken !== null && CAMPAIGN_TOKEN_IN_URL !== undefined) {
            SESSION_API.clearSession();
        }

        if ($STATE.campaignToken !== null && MAGIC_TOKEN_IN_URL !== undefined) {
            SESSION_API.clearSession();
        }

        await checkCachedToken();

        if ($TOKEN !== undefined && $SESSION_ORGANIZATION?._.state === 'approved') {
            return;
        }

        if (CAMPAIGN_TOKEN_IN_URL === undefined) {
            return;
        }

        await checkCampaignToken();
    };

    const extractEmailFromUrl = (): void => {
        const EMAIL = QUERY_STATE.getParameter('email');

        if (EMAIL === undefined) {
            return;
        }

        $AUTHENTICATION.email = EMAIL as string;
        QUERY_STATE.removeParameter('email');
    };

    onMount(() => {
        extractEmailFromUrl();
    });

</script>

<Loader />

{#await checkTokens() then }
    <Router />
{/await}